import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';
import UpdateUserForm from './forms/updateUserForm';
import { selectProfileUpdatingFlag } from 'redux/user/selector';
import { APP } from 'app/AppRoutes';

const Profile = () => {
  const isOpenProfile = useSelector(selectProfileUpdatingFlag);
  const [apiError, setApiError] = useState<null | string>(null);

  return (
    <>
      {isOpenProfile &&
        ReactDOM.createPortal(
          <UpdateUserForm apiError={apiError} setApiError={setApiError} />,
          document.querySelector(`#${APP}`) || document.body
        )}
    </>
  );
};

Profile.displayName = 'Profile';
export default Profile;
